import { styled } from '@linaria/react';
import { fonts, layout, radius, semantic, space } from '../../theme/tokens';

export const Card = styled.div`
  background: ${semantic.bg.surfaceSubtle};
  border-radius: ${radius('card', 'radius-xl')};
  padding: ${space['space-600']} ${space['space-500']};
  display: flex;
  flex-direction: column;
  gap: ${space['space-500']};

  @media (min-width: ${layout.desktopBreakpoint}) {
    padding: ${space['space-800']};
  }
`;

export const HeadingGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-100']};
`;

export const Heading = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.base};
  font-weight: ${fonts.weight.normal};
  color: ${semantic.text.primary};
`;

export const Subheading = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.base};
  font-weight: ${fonts.weight.normal};
  color: ${semantic.text.secondary};
`;
